import React from "react";
import {useSelector} from "react-redux";
import {css, Theme} from "@emotion/react";

import {Container} from "@pg-design/grid-module";
import {m, mt, mv, onDesktop, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text";
import {FaqSection} from "@pg-mono/faq";

import {IRPStore} from "../../app/rp_reducer";
import {CreditCalculatorPictograms} from "../components/CreditCalculatorPictograms";
import {CreditKnowledgeBase} from "../components/CreditKnowledgeBase";
import {CreditRatingHeader} from "../components/CreditRatingHeader";
import {CreditBreadcrumbs, CreditBreadcrumbType} from "../components/CreditsBreadcrumbs";
import {CreditRatingCalculator} from "../components/raiting_calculator/CreditRatingCalculator";
import {PictogramType} from "../types/PictogramType";

export const CreditRatingCalculatorView = () => {
    const faq = useSelector((state: IRPStore) => state.faq.data);

    return (
        <>
            <CreditBreadcrumbs breadcrumbType={CreditBreadcrumbType.RATING} />

            <div css={mainWrapper}>
                <CreditRatingHeader />

                <CreditRatingCalculator />

                <Container as="section" css={mv(12)}>
                    <Text variant="headline_3" as="p" css={calcViewHeadline} strong={false}>
                        Kalkulator zdolności kredytowej, czyli…
                    </Text>
                    <CreditCalculatorPictograms variant={PictogramType.LABELED_ICON} componentsMobileGap={8} />
                </Container>

                <CreditKnowledgeBase />
                <FaqSection faqContent={faq} css={mt(6)} />
            </div>
        </>
    );
};

const calcViewHeadline = css`
    text-align: center;
    margin: 1.5rem 0 6rem 0;
`;

const mainWrapper = (theme: Theme) => css`
    ${m("auto")}

    background-color: ${theme.colors.background["100"]};
    ${onDesktop(css`
        ${p(3)};
        max-width: 112.8rem;
    `)};
`;
import React from "react";
import {useSelector} from "react-redux";
import {css, Theme} from "@emotion/react";

import {Container} from "@pg-design/grid-module";
import {m, mt, mv, onDesktop, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text";
import {FaqSection} from "@pg-mono/faq";

import {IRPStore} from "../../app/rp_reducer";
import {CreditCalculatorPictograms} from "../components/CreditCalculatorPictograms";
import {CreditKnowledgeBase} from "../components/CreditKnowledgeBase";
import {CreditRatingHeader} from "../components/CreditRatingHeader";
import {CreditBreadcrumbs, CreditBreadcrumbType} from "../components/CreditsBreadcrumbs";
import {CreditRatingCalculator} from "../components/raiting_calculator/CreditRatingCalculator";
import {PictogramType} from "../types/PictogramType";

export const CreditRatingCalculatorView = () => {
    const faq = useSelector((state: IRPStore) => state.faq.data);

    return (
        <>
            <CreditBreadcrumbs breadcrumbType={CreditBreadcrumbType.RATING} />

            <div css={mainWrapper}>
                <CreditRatingHeader />

                <CreditRatingCalculator />

                <Container as="section" css={mv(12)}>
                    <Text variant="headline_3" as="p" css={calcViewHeadline} strong={false}>
                        Kalkulator zdolności kredytowej, czyli…
                    </Text>
                    <CreditCalculatorPictograms variant={PictogramType.LABELED_ICON} componentsMobileGap={8} />
                </Container>

                <CreditKnowledgeBase />
                <FaqSection faqContent={faq} css={mt(6)} />
            </div>
        </>
    );
};

const calcViewHeadline = css`
    text-align: center;
    margin: 1.5rem 0 6rem 0;
`;

const mainWrapper = (theme: Theme) => css`
    ${m("auto")}

    background-color: ${theme.colors.background["100"]};
    ${onDesktop(css`
        ${p(3)};
        max-width: 112.8rem;
    `)};
`;
